/**
 * お客様の声（voice）・スタッフ（staffVoiceCard）PC のみ:
 * 左列と画像列のグリッドで align-items: end のとき、本文上端と画像上端を揃える。
 * 左列高さ L が T + figH 未満のときは margin-top を max(0, L - figH) に抑える。
 */
const MQ_PC = '(min-width: 768px)';

/** @typedef {{ cardSelector: string; left: string; blockquote: string; text: string; figure: string; noTextClass: string }} CardFigureAlignConfig */

/** @type {CardFigureAlignConfig[]} */
const CONFIGS = [
	{
		cardSelector: '.voice__card',
		left: '.voice__cardLeft',
		blockquote: '.voice__cardBlockquote',
		text: '.voice__cardText',
		figure: '.voice__cardFigure',
		noTextClass: 'voice__card--noText',
	},
	{
		cardSelector: '.staffVoiceCard',
		left: '.staffVoiceCard__left',
		blockquote: '.staffVoiceCard__blockquote',
		text: '.staffVoiceCard__text',
		figure: '.staffVoiceCard__figure',
		noTextClass: 'staffVoiceCard--noText',
	},
];

function debounce(fn, ms) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(null, args), ms);
	};
}

function textMarginTopPx(textEl) {
	if (!textEl) return 0;
	const cs = getComputedStyle(textEl);
	if (cs.display === 'none') return 0;
	const v = parseFloat(cs.marginTop);
	return Number.isFinite(v) ? v : 0;
}

/**
 * @param {Element} card
 * @param {CardFigureAlignConfig} cfg
 * @param {boolean} isPc
 */
function updateOneCard(card, cfg, isPc) {
	const figure = card.querySelector(cfg.figure);
	const bq = card.querySelector(cfg.blockquote);
	if (!figure || !bq) return;

	if (!isPc) {
		figure.style.removeProperty('margin-top');
		figure.style.removeProperty('align-self');
		return;
	}

	const left = card.querySelector(cfg.left);
	const textEl = card.querySelector(cfg.text);
	const textGap = card.classList.contains(cfg.noTextClass) ? 0 : textMarginTopPx(textEl);
	const T = Math.round(bq.offsetHeight + textGap);
	const figH = Math.round(figure.offsetHeight);
	const L = left ? Math.round(left.offsetHeight) : 0;

	const marginTop = L >= T + figH ? T : Math.max(0, L - figH);

	figure.style.alignSelf = 'start';
	figure.style.marginTop = `${marginTop}px`;
}

/**
 * @param {Array<{ card: Element; cfg: CardFigureAlignConfig }>} entries
 * @param {MediaQueryList} mqPc
 */
function updateAll(entries, mqPc) {
	const isPc = mqPc.matches;
	for (const { card, cfg } of entries) {
		updateOneCard(card, cfg, isPc);
	}
}

export function init() {
	/** @type {Array<{ card: Element; cfg: CardFigureAlignConfig }>} */
	const entries = [];
	for (const cfg of CONFIGS) {
		document.querySelectorAll(cfg.cardSelector).forEach((card) => {
			entries.push({ card, cfg });
		});
	}
	if (!entries.length) return;

	const mqPc = window.matchMedia(MQ_PC);
	const run = () => updateAll(entries, mqPc);

	run();

	const debouncedRun = debounce(run, 100);
	window.addEventListener('resize', debouncedRun);

	if (typeof mqPc.addEventListener === 'function') {
		mqPc.addEventListener('change', run);
	} else {
		mqPc.addListener(run);
	}

	if (document.fonts?.ready) {
		document.fonts.ready.then(run);
	}

	if (typeof ResizeObserver !== 'undefined') {
		const ro = new ResizeObserver(debouncedRun);
		for (const { card } of entries) {
			ro.observe(card);
		}
	}
}
